<template>
    <div
        class="channels-item"
        :class="{
            healthy: isBusiness ? true : !!(channelInfos[channel._id] && channelInfos[channel._id].status.ready),
            dead: isBusiness ? false : !(channelInfos[channel._id] && channelInfos[channel._id].status.ready),
        }"
    >
        <div class="first" @click="goToDetail">
            <div @click="goToDetail" class="icon-wrapper">
                <WhatsappBusinessIcon className="channel-icon" v-if="isBusiness" :color="'#179d0d'" />
                <WhatsappV1 class="channel-icon" v-if="isV1" :color="color" />
                <WhatsappV2 class="channel-icon" v-if="isV2" :color="color" />
                <InstagramIcon class="channel-icon" v-if="isInstagram" special-background-mode />
                <MessengerIcon class="channel-icon" v-if="isMessenger" special-background-mode />
                <img src="/static/img/postacell-logo.png" v-if="smsPostacell" style="max-width: 50px" />
            </div>
            <div
                class="channel-name"
                v-tippy="{
                    followCursor: true,
                    placement: 'bottom-end',
                    theme: isDarkMode ? 'light-border' : 'google',
                }"
                :content="getChannelType + channel.name.toUpperCase()"
            >
                {{ channel.name }}
            </div>
        </div>
        <div class="actions">
            <IconButton :on-click="() => $router.push(broadcastRequestURL)" v-if="whatsappModal">
                <span
                    class="md-icon md-icon-style"
                    v-tippy="{
                        followCursor: true,
                        placement: 'bottom-end',
                        theme: isDarkMode ? 'light-border' : 'google',
                    }"
                    @click=""
                    :content="$t('wp.broadcast.broadcast')"
                >
                    campaign</span
                >
            </IconButton>
            <a-divider type="vertical" />
            <IconButton :on-click="openModal" v-if="whatsappModal">
                <span
                    class="md-icon md-icon-style"
                    v-tippy="{
                        followCursor: true,
                        placement: 'bottom-end',
                        theme: isDarkMode ? 'light-border' : 'google',
                    }"
                    @click=""
                    :content="'Start Chat'"
                >
                    forum
                </span>
            </IconButton>
            <IconButton :on-click="openSmsModal" v-if="smsModal">
                <span
                    class="md-icon md-icon-style"
                    v-tippy="{
                        followCursor: true,
                        placement: 'bottom-end',
                        theme: isDarkMode ? 'light-border' : 'google',
                    }"
                    @click=""
                    :content="'SEND SMS'"
                >
                    forum
                </span>
            </IconButton>
            <IconButton :on-click="() => goToContacts()" v-if="this.isInstagram || this.isMessenger">
                <span
                    class="md-icon md-icon-style"
                    v-tippy="{
                        followCursor: true,
                        placement: 'bottom-end',
                        theme: isDarkMode ? 'light-border' : 'google',
                    }"
                    @click=""
                    :content="$t('ticimax.members')"
                >
                    group</span
                >
            </IconButton>
            <IconButton :on-click="() => goToFilteredTicket()" v-if="this.isInstagram || this.isMessenger" style="margin-left: 10px">
                <span
                    class="md-icon md-icon-style"
                    v-tippy="{
                        followCursor: true,
                        placement: 'bottom-end',
                        theme: isDarkMode ? 'light-border' : 'google',
                    }"
                    @click=""
                    :content="$t('search.ticket')"
                >
                    confirmation_number</span
                >
            </IconButton>
        </div>

        <a-modal v-model="showModal" :title="$t('tour.startChat')" @ok="closeModal" width="1000px" :footer="null">
            <WhatsappContactList :channel="channel" :channel-id="channel._id" :allowImport="false" />
        </a-modal>
        <a-modal v-model="smsStartChat" :title="$t('tour.startChat')" @ok="closeSmsModal" :footer="null">
            <div class="send-sms-v2">
                <SendSmsInput :default-phone-number="phoneNumber" @sendSMS="sendSMS" />
            </div>
        </a-modal>
    </div>
</template>
<script>
import Vue from "vue";
import WhatsappBusinessIcon from "../../views/Pages/Chatbot/pages/integrations/svg/WhatsappBusinessIcon.vue";
import { mapGetters, mapState } from "vuex";
import IconButton from "../../views/Pages/Settings/components/IconButton.vue";
import WhatsappV2 from "../../views/Pages/Chatbot/pages/integrations/svg/specialWhatsappIcon/WhatsappV2.vue";
import WhatsappV1 from "../../views/Pages/Chatbot/pages/integrations/svg/specialWhatsappIcon/WhatsappV1.vue";

import { generateUUID } from "../../utils/session";
import { sendSocketMessage } from "../../utils/socketStream";
import WhatsappContactList from "../../views/Pages/WhatsappItem/WhatsappContactList.vue";
import SendSmsInput from "../../views/Pages/Integrations/SMS/PostaCell/detail/SendSmsInput.vue";
import InstagramIcon from "../../views/Pages/Chatbot/pages/integrations/svg/InstagramIcon.vue";
import MessengerIcon from "../../views/Pages/Chatbot/pages/integrations/svg/MessengerIcon.vue";

export default Vue.extend({
    name: "ChannelStatusItem",
    components: {
        MessengerIcon,
        InstagramIcon,
        WhatsappV1,
        WhatsappV2,
        IconButton,
        WhatsappBusinessIcon,
        SendSmsInput,
        WhatsappContactList,
    },
    props: {
        channel: {
            type: Object,
            required: true,
        },
        smsModal: {
            type: Boolean,
            default: false,
        },
        whatsappModal: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
        }),
        ...mapState({
            channelInfos: (state) => state.whatsapp.channelInfo,
            site: (state) => state.site.site,
        }),
        getChannelType() {
            if (this.channel.type === "instagram"){
                return this.$t('message.instagramChannel');
            }
            else if (this.channel.type === "messenger"){
                return this.$t('message.messengerChannel');
            }
            else if (this.channel.type === "whatsapp-business-api"){
                return this.$t('message.wBChannel');
            }
            else if (this.channel.type === "whatsapp-qr"){
                return this.$t('message.whatsappv1Channel');
            }
            else if (this.channel.type === "whatsapp-v2"){
                return this.$t('message.whatsappv2Channel');
            }
            else if (this.channel.type === "sms-postacell"){
                return this.$t('message.smsChannel');
            }
        },
        isInstagram() {
            return this.channel.type === "instagram";
        },
        isMessenger() {
            return this.channel.type === "messenger";
        },
        isBusiness() {
            return this.channel.type === "whatsapp-business-api";
        },
        isV2() {
            return this.channel.type === "whatsapp-v2";
        },
        isV1() {
            return this.channel.type === "whatsapp-qr";
        },
        smsPostacell() {
            return this.channel.type === "sms-postacell";
        },
        isHealthy() {
            return this.isBusiness
                ? true
                : !!(this.channelInfos[this.channel._id] && this.channelInfos[this.channel._id].status.ready);
        },
        detailURL() {
            if (this.isInstagram) {
                return `/integrations/instagram/${this.channel._id}/detail`;
            } else if (this.isMessenger) {
                return `/integrations/messenger/${this.channel._id}/detail`;
            } else if (this.isBusiness) {
                return `/integrations/whatsapp-business-api/${this.channel._id}/detail`;
            } else if (this.isV1) {
                return `/integrations/whatsapp-v1/${this.channel._id}/detail`;
            } else if (this.isV2) {
                return `/integrations/whatsapp-v2/${this.channel._id}/detail`;
            } else if (this.smsPostacell) {
                return `/integrations/sms/postacell/${this.channel._id}/detail`;
            }
        },
        broadcastRequestURL() {
            const isBusiness = this.channel.type === "whatsapp-business-api";
            const isV1 = this.channel.type === "whatsapp-qr";
            const isV2 = this.channel.type === "whatsapp-v2";
            const smsPostacell = this.channel.type === "sms-postacell";
            if (this.isBusiness) {
                return `/integrations/whatsapp-business-api/${this.channel._id}/detail/broadcast-requests`;
            }
            if (this.isV1) {
                return `/integrations/whatsapp-v1/${this.channel._id}/detail/broadcast-requests`;
            }
            if (this.isV2) {
                return `/integrations/whatsapp-v2/${this.channel._id}/detail/broadcast-requests`;
            }
            if (this.smsPostacell) {
                return `/integrations/sms/postacell/${this.channel._id}/detail/postacellAllMessage`;
            }
        },
        color() {
            return this.isHealthy ? "#179d0d" : "red";
        },
    },
    data() {
        return {
            showModal: false,
            smsStartChat: false,
            phoneNumber: "",
        };
    },
    methods: {
        goToFilteredTicket(){
            if (this.isInstagram) {
                this.$router.push({ path: '/ticket', query: { platform: 'instagram' } });
            } else {
                this.$router.push({ path: '/ticket', query: { platform: 'messenger' } });
            }
        },
        goToContacts() {

            if (this.isInstagram) {
                this.$router.push({ path: '/chat', query: { tabIndex: '9' } });
            } else {
                this.$router.push({ path: '/chat', query: { tabIndex: '10' } });
            }
        },
        closeModal() {
            this.showModal = false;
        },
        openModal(e) {
            this.showModal = true;
            e.preventDefault();
            e.stopPropagation();
        },
        openSmsModal(e) {
            this.smsStartChat = true;
            e.preventDefault();
            e.stopPropagation();
        },
        closeSmsModal() {
            this.smsStartChat = false;
        },
        goToDetail() {
            this.$router.push(this.detailURL);
        },
        async sendSMS({ text, channelId, senderId, number }) {
            const payload = {
                siteId: this.site._id,
                channelId,
                channelType: "sms-postacell",
                number,
                message: text,
                senderId,
                title: null,
                customMessageId: generateUUID(),
            };
            sendSocketMessage("sms send-single", payload);
        },
    },
});
</script>

<style scoped lang="scss">
.sms-input {
    box-shadow: none !important;
}

.channels-item {
    display: flex;
    justify-content: space-between;
    padding: 5px 10px;
    width: 100%;
    align-items: center;
    border-bottom: 1px solid var(--color-border-default);

    &:hover {
        cursor: pointer;
        background-color: var(--color-bg-hover);
    }

    .icon-wrapper {
        width: 25px !important;
        height: 25px !important;
        display: flex;
        justify-content: center !important;
        align-items: center !important;

        .channel-icon {
            width: 25px !important;
            height: 25px !important;
        }
    }

    .first {
        display: flex;
        flex-direction: row;
        gap: 5px;
        align-items: center;
        width: 100%;

        .channel-name {
            width: 100%;
            font-weight: 600;
        }
    }

    .actions {
        width: 75px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        gap: 2px;

        .icon-button {
            width: 24px !important;
            height: 24px !important;
            padding: 0 !important;

            &:hover {
                color: #faa566;
            }
        }

        .icon-button:last-child {
            border-right: none;
        }
    }
}

.send-sms-v2 {
    margin-left: 38px !important;
}
</style>
